import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
const __default__ = {
  name: "GradeIndex"
};
import { ref } from "vue";
import { useStore } from "vue2-helpers/vuex";
import { getData, createData } from "@/services/axios";
import sortableList from "@/components/common/SortableList.vue";
import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props, {
    expose
  }) {
    // @ts-check
    const {
      grades,
      classrooms
    } = storeToRefs(useGradeClassroomStore());
    const store = useStore();
    const isLoading = ref(true);
    const gradeSortList = ref([]);

    const setData = async () => {
      // 初期取得時からgradeが既に変更されている可能性も考えて取得しなおす
      isLoading.value = true;

      try {
        const data = await getData("grades?with=classroom");
        store.dispatch("commitGrade", data.items);
        grades.value = data.items;
        gradeSortList.value = structuredClone(data.items);
      } catch (error) {
        console.log(error);
      }

      isLoading.value = false;
    };

    const saveOrder = async () => {
      isLoading.value = true;

      try {
        await createData("writer/write_grade_index", {
          grades: gradeSortList.value
        }); // 更新後は学年だけでなくクラス順にも影響を及ぼすので取得しなおす

        const data = await getData(["grades?with=classroom", "reader/get_classroom_with_students_count"]);
        store.dispatch("commitGrade", data[0].items);
        grades.value = data[0].items;
        gradeSortList.value = structuredClone(data[0].items);
        store.dispatch("commitClassroom", data[1].items);
        classrooms.value = data[1].items;
      } catch (error) {
        console.log(error);
      }

      isLoading.value = false;
    };

    const cancelOrder = () => {
      setData();
    }; // created


    setData();
    expose({
      grades,
      gradeSortList,
      setData
    });
    return {
      __sfc: true,
      grades,
      classrooms,
      store,
      isLoading,
      gradeSortList,
      setData,
      saveOrder,
      cancelOrder,
      sortableList
    };
  }

});